import { useSelector } from 'react-redux';
import { getActiveLocaleSelector, getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { useMembershipDomainFetchye } from '@americanexpress/consumer-travel-base';
import { capitaliseFirstLetterUtil } from '../utils/capitaliseFirstLetterUtil';
import { hasVacationRentalsRule } from '../constants/featureRulesConstants';
import { MODULE_NAME } from '../constants/modules';
import { MEMBERSHIP_QUERY } from '../graphql/membership';

export const useMembershipApi = () => {
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const activeLocale = useSelector(getActiveLocaleSelector);
  const hasVacationRentals = useConditionalFeature(hasVacationRentalsRule);

  const fetcherOpts = {
    reporting: {
      moduleID: MODULE_NAME,
      componentID: 'useMembershipApi',
      fetch: {
        activeLocale,
      },
    },
  };

  const { data, isLoading, error } = useMembershipDomainFetchye(
    { query: MEMBERSHIP_QUERY },
    {
      defer: !isLoggedIn || !hasVacationRentals,
    },
    fetcherOpts
  );

  return { data, isLoading, error };
};

export const useFirstName = () => {
  const { data: membershipData } = useMembershipApi();
  let firstName = null;

  if (Array.isArray(membershipData?.data?.membership)) {
    firstName = membershipData?.data?.membership[0]?.demographics?.firstName;
  }

  firstName = firstName && capitaliseFirstLetterUtil(firstName);
  return firstName;
};

export const useAccountToken = () => {
  const { data: membershipData } = useMembershipApi();
  let accountToken = null;

  if (Array.isArray(membershipData?.data?.membership)) {
    accountToken = membershipData?.data?.membership[0]?.accountToken;
  }

  return accountToken;
};
